import { Button, Dialog, DialogContent, DialogActions, TextField, Snackbar, MenuItem } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { useState } from 'react'
import { useNavigate } from 'react-router-dom';

export default function NewReportDialog(props)
{
	const navigate = useNavigate();
	const {variant} = props;
	const {projects,zones} = props;
	const [open, setOpen] = useState(false);

	const handleClick = ()=>{
		setOpen(true);
	};

	const handleClose = () => {
		setProject("");
		setZone("");
		setOpen(false);
	};

	const [zone, setZone] = useState("")
	const onZoneChange = e => setZone(e.target.value)

	const [project, setProject] = useState("")
	const onProjectChange = (e) => {
		setProject(e.target.value);
		setZone("");
	}

	const [errorReason,setErrorReason] = useState("");
	const [openErrorSnack, setOpenErrorSnack] = useState(false);
	const handleErrorSnackClose = ()=>
	{
		setErrorReason("");
		setOpenErrorSnack(false);
	}

	const makeError = (reason)=>{
		setErrorReason(reason);
		setOpenErrorSnack(true);
	}

	const handleSubmit=()=>
	{
		if(project === "")
		{
			makeError("NO PROJECT SELECTED!");
			return;
		}
		if(zone === "")
		{
			makeError("NO ZONE SELECTED!");
			return;
		}
		navigate(`/activity/${encodeURIComponent(project)}/${encodeURIComponent(zone)}`, { state: { project, zone } });
	}

	return (
		<>
		<Button size="small" onClick={handleClick} variant={variant}>New Report</Button>
		<Snackbar open={openErrorSnack} autoHideDuration={5000} onClose={handleErrorSnackClose} anchorOrigin={{ vertical:"top", horizontal:"center" }}>
				<MuiAlert variant="filled" severity="error">
					{errorReason}
				</MuiAlert>
		</Snackbar>
		<Dialog onClose={handleClose} open={open}>
			<DialogContent sx={{ minWidth: "500px" }}>
				<TextField select label={"Project"} onChange={onProjectChange} helperText={"Select a project"} fullWidth value={project}>
					{
						projects.map(project => (
							<MenuItem key={project.id} value={project.id}>
								{`${project.name} ${project.year}`}
							</MenuItem>)
						)
					}
				</TextField>
				<TextField select label={"Zone"} onChange={onZoneChange} helperText={"Select a zone"} fullWidth value={zone}>
					{
						zones.filter(
							zone => {return zone.project === project}
						).map(
							zone => (
								<MenuItem key={zone.id} value={zone.zone}>
									{zone.zone}
								</MenuItem>
							)
						)
					}
				</TextField>
			</DialogContent>
			<DialogActions>
				<Button variant='contained' onClick={handleSubmit}>Next</Button>
			</DialogActions>
		</Dialog>
		</>
	);
}